import { render, staticRenderFns } from "./userTransactions.vue?vue&type=template&id=59355d9a&scoped=true"
import script from "./userTransactions.vue?vue&type=script&lang=js"
export * from "./userTransactions.vue?vue&type=script&lang=js"
import style0 from "./userTransactions.vue?vue&type=style&index=0&id=59355d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59355d9a",
  null
  
)

export default component.exports